import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types for Fetching Categories
export const FETCH_CATEGORIES_REQUEST = 'FETCH_CATEGORIES_REQUEST';
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILURE = 'FETCH_CATEGORIES_FAILURE';

// Action Types for Adding Category
export const ADD_CATEGORY_REQUEST = 'ADD_CATEGORY_REQUEST';
export const ADD_CATEGORY_SUCCESS = 'ADD_CATEGORY_SUCCESS';
export const ADD_CATEGORY_FAILURE = 'ADD_CATEGORY_FAILURE';

// Action Types for Deleting Category
export const DELETE_CATEGORY_REQUEST = 'DELETE_CATEGORY_REQUEST';
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_FAILURE = 'DELETE_CATEGORY_FAILURE';

// Action Types
export const UPDATE_CATEGORY_REQUEST = 'UPDATE_CATEGORY_REQUEST';
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS';
export const UPDATE_CATEGORY_FAILURE = 'UPDATE_CATEGORY_FAILURE';

// Action Types for Swapping Category Order
export const SWAP_CATEGORIES_REQUEST = 'SWAP_CATEGORIES_REQUEST';
export const SWAP_CATEGORIES_SUCCESS = 'SWAP_CATEGORIES_SUCCESS';
export const SWAP_CATEGORIES_FAILURE = 'SWAP_CATEGORIES_FAILURE';

// Action Creators for Fetching Categories
export const fetchCategoriesRequest = () => ({
  type: FETCH_CATEGORIES_REQUEST,
});

export const fetchCategoriesSuccess = (categories) => ({
  type: FETCH_CATEGORIES_SUCCESS,
  payload: categories,
});

export const fetchCategoriesFailure = (error) => ({
  type: FETCH_CATEGORIES_FAILURE,
  payload: error,
});

// Action Creators for Adding Category
export const addCategoryRequest = () => ({
  type: ADD_CATEGORY_REQUEST,
});

export const addCategorySuccess = (category) => ({
  type: ADD_CATEGORY_SUCCESS,
  payload: category,
});

export const addCategoryFailure = (error) => ({
  type: ADD_CATEGORY_FAILURE,
  payload: error,
});




// Action Creators for Deleting Category
export const deleteCategoryRequest = () => ({
  type: DELETE_CATEGORY_REQUEST,
});

export const deleteCategorySuccess = (categoryId) => ({
  type: DELETE_CATEGORY_SUCCESS,
  payload: categoryId,
});

export const deleteCategoryFailure = (error) => ({
  type: DELETE_CATEGORY_FAILURE,
  payload: error,
});

// Action Creators
export const updateCategoryRequest = () => ({
  type: UPDATE_CATEGORY_REQUEST,
});

export const updateCategorySuccess = (category) => ({
  type: UPDATE_CATEGORY_SUCCESS,
  payload: category,
});

export const updateCategoryFailure = (error) => ({
  type: UPDATE_CATEGORY_FAILURE,
  payload: error,
});

// Swap Categories Thunk
export const swapCategoryOrder = (categoryId1, categoryId2) => {
  return async (dispatch, getState) => {
    const { categories } = getState().categories;
    const idx1 = categories.findIndex((c) => c._id === categoryId1);
    const idx2 = categories.findIndex((c) => c._id === categoryId2);
    if (idx1 === -1 || idx2 === -1) return;

    // Optimistic update
    const newCategories = [...categories];
    [newCategories[idx1], newCategories[idx2]] = [newCategories[idx2], newCategories[idx1]];
    dispatch({ type: SWAP_CATEGORIES_SUCCESS, payload: newCategories });

    const token = localStorage.getItem('token');
    try {
      await axios.put(
        `${BASE_URL}/v1/api/categories/swap-order`,
        { categoryId1, categoryId2 },
        { headers: { authorization: `${token}` } }
      );
    } catch (error) {
      // Revert on failure
      dispatch({ type: SWAP_CATEGORIES_SUCCESS, payload: categories });
      const errorMessage = error.response?.data?.message || error.message;
      dispatch({ type: SWAP_CATEGORIES_FAILURE, payload: errorMessage });
      throw new Error(errorMessage);
    }
  };
};

// Fetch Categories Thunk
export const fetchCategories = () => {
  return async (dispatch) => {
    dispatch(fetchCategoriesRequest());
    const token = localStorage.getItem('token'); // Get token from localStorage

    try {
      const response = await axios.get(`${BASE_URL}/v1/api/categories`, {
        headers: {
          authorization: `${token}`, // Pass token in Authorization header
        },
      });
      dispatch(fetchCategoriesSuccess(response.data.data));
    } catch (error) {
      // More specific error handling
      const errorMessage = error.response?.data?.message || error.message;
      dispatch(fetchCategoriesFailure(errorMessage));
    }
  };
};

// Add Category Thunk
export const addCategory = (categoryData) => {
  return async (dispatch) => {
    dispatch(addCategoryRequest());
    const token = localStorage.getItem('token'); // Get token from localStorage

    try {
      const response = await axios.post(`${BASE_URL}/v1/api/category`, categoryData, {
        headers: {
          authorization: `${token}`, // Pass token in Authorization header
        },
      });
      dispatch(addCategorySuccess(response.data.data)); // Dispatch success with the added category
    } catch (error) {
      // More specific error handling
      const errorMessage = error.response?.data?.message || error.message;
      dispatch(addCategoryFailure(errorMessage)); // Dispatch failure if there's an error
    }
  };
};


// Delete Category Thunk
export const deleteCategory = (categoryId) => {
  return async (dispatch) => {
    dispatch(deleteCategoryRequest());
    const token = localStorage.getItem('token'); // Get token from localStorage

    try {
      await axios.delete(`${BASE_URL}/v1/api/category/${categoryId}`, {
        headers: {
          authorization: `${token}`, // Pass token in Authorization header
        },
      });
      dispatch(deleteCategorySuccess(categoryId)); // Dispatch success with categoryId
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      dispatch(deleteCategoryFailure(errorMessage)); // Dispatch failure if there's an error
    }
  };
};


// Update Category Thunk
export const updateCategory = (categoryId, categoryData) => {
  return async (dispatch) => {
    dispatch(updateCategoryRequest());
    const token = localStorage.getItem("token");

    try {
      const response = await axios.put(
        `${BASE_URL}/v1/api/category/${categoryId}`,
        categoryData,
        {
          headers: {
            authorization: `${token}`,
          },
        }
      );
      dispatch(updateCategorySuccess(response.data.data));
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      dispatch(updateCategoryFailure(errorMessage));
      throw new Error(errorMessage); // Handle error in component
    }
  };
};